import styled from 'styled-components'
import { Margin, Padding, TMarginMixin, TPaddingMixin } from '../styles/mixins'

export const ListItem = styled.li<TMarginMixin & TPaddingMixin>`
  list-style: none;
  ${(props: TMarginMixin) => Margin({ ...props })};
  ${(props: TPaddingMixin) => Padding({ ...props })};
`
